// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestMove {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private async onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        const c = new vf.gui.Container();
        c.interactabled = true;
        uiStage.addChild(c);

        const img3  = new vf.gui.Image();
        img3.interactabled = true;
        img3.x = uiStage.width >> 1;
        img3.y = 100;
        img3.src = "assets/dino.png";
        c.addChild(img3);


        img3.on('down',()=>{
            console.log('down');
            c.hitArea.x = 0;
            c.hitArea.y = 0;
            c.hitArea.width = uiStage.width;
            c.hitArea.height = uiStage.height;
            c.on("move",(e: vf.InteractionEvent)=>{
                const p = vf.gui.Utils.toLocal(e.data.global,c)
                img3.x = p.x - 100;
                img3.y = p.y - 150;
                console.log("move");
            })
        });

        img3.on('up',()=>{
            console.log('up');
            c.offAll();
        });





    }
}
